import { render } from "./edicionManualTarjeta.vue?vue&type=template&id=ec07d484"
import script from "./edicionManualTarjeta.vue?vue&type=script&lang=js"
export * from "./edicionManualTarjeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__